export const FLAG_ENABLE_SEARCH_PAGE =
  process.env.REACT_APP_FLAG_ENABLE_SEARCH_PAGE === 'true'
